// src/com/veh_type_group/VehTypeManager.js
import React, { useState } from 'react';
import TopViewControl from '../../common/TopViewControl';
import ViewTabs from '../../common/ViewTabs';
import VehTypeGroup from './VehTypeGroup';
import VehTypeInfo from '../veh_type_info/VehTypeInfo';
import VehTypeGroupCode from '../veh_type_group_code/VehTypeGroupCode';

const VehTypeCommand = {VehTypeGroup:1, VehTypeInfo:2, VehTypeGroupCode:3};

const ViewMetaInfo = [
    {id:VehTypeCommand.VehTypeGroup, label:'차종그룹관리'},
    {id:VehTypeCommand.VehTypeInfo, label:'차종정보'},
    {id:VehTypeCommand.VehTypeGroupCode, label:'차종그룹정보'}
]

export default function VehTypeManager() {
    const [selectedTabId, setSelectedTabId] = useState(ViewMetaInfo[0].id);

    const onChangeTab = (v) => {
        setSelectedTabId(v);
    };

    const viewTabs = <ViewTabs selectedTabId={selectedTabId} viewMetas={ViewMetaInfo} onChangeTab={onChangeTab} />;

    return(
        <TopViewControl>
            {
                (() => {
                    if(selectedTabId===VehTypeCommand.VehTypeInfo) return <VehTypeInfo tabsForSwitchingView={viewTabs} />;
                    else if(selectedTabId===VehTypeCommand.VehTypeGroupCode) return <VehTypeGroupCode tabsForSwitchingView={viewTabs} />;
                    else return <VehTypeGroup tabsForSwitchingView={viewTabs} />;
                })()
            }
        </TopViewControl>
    );
}